/**
 * Hero-illustratie – Persoon met laptop in huiselijke setting
 * Zonder `alt`: decoratief (aria-hidden). Met `alt`: zichtbare beschrijving voor screenreaders en SEO.
 */
export function HeroIllustration({ className = '', alt }: { className?: string; alt?: string }) {
  const decorative = alt === undefined;
  return (
    <img
      src="/assets/hero-person-laptop.png"
      alt={decorative ? '' : alt}
      className={className}
      style={{ objectFit: 'contain' }}
      loading="eager"
      decoding="async"
      fetchPriority="high"
      {...(decorative ? { 'aria-hidden': true as const } : {})}
    />
  );
}
